import { env } from '@zopauk/nextjs-env';

type StaticTheme = {
  basePath: string;
  theme: string;
  gtm: string;
};

const zopaTheme: StaticTheme = {
  gtm: 'GTM-TGVNPH4',
  theme: 'zopa',
  basePath: '',
};

const johnlewisTheme: StaticTheme = {
  basePath: '/personal-loans-quote',
  gtm: 'GTM-PVD8WVZV',
  theme: 'jl-money',
};

export const staticTheme = (): StaticTheme => (env('NEXT_PUBLIC_THEME') === 'jl-money' ? johnlewisTheme : zopaTheme);

export type { StaticTheme as Theme };
